<template>
  <header id="gel-header" class="py-3 px-lg-5 py-xxl-5" role="banner">
    <div class="mb-3 mb-lg-0 d-lg-none">
      <a href="#" class="nav-toggle text-muted" aria-label="Toggle menu" aria-expanded="false">
        <i aria-hidden="true" class="gel-icon-menu gel-icon-lg" @click="openMenu"></i>
      </a>
    </div>
    <div class="container py-3">
      <div class="row">
        <div class="offset-xl-1 col-xl-10 offset-xxl-2 col-xxl-8">
          <h1 class="display-3 text-primary">
            {{ title }}
          </h1>
          <blockquote class="tagline text-20" v-html="tagline"></blockquote>
        </div>
      </div>
    </div>
    <div class="viewport-detector">
      <span class="badge badge-warning d-sm-none"><i class="gel-icon-iphone"></i><i class="gel-icon-tablet disabled"></i><i class="gel-icon-laptop disabled"></i> XS &lt; 576px </span> 
      <span class="d-none badge badge-info d-sm-inline-block d-md-none"><i class="gel-icon-iphone rotate-90"></i><i class="gel-icon-tablet disabled"></i><i class="gel-icon-laptop disabled"></i> - SM ≥ 576px
      </span>
      <span class="d-none badge badge-success d-md-inline-block d-lg-none"><i class="gel-icon-iphone disabled"></i><i class="gel-icon-tablet rotate-90"></i><i class="gel-icon-laptop disabled"></i> - MD ≥ 768px
      </span>
      <span class="d-none badge badge-danger d-lg-inline-block d-xl-none"><i class="gel-icon-iphone disabled"></i><i class="gel-icon-tablet"></i><i class="gel-icon-laptop disabled"></i> - LG ≥ 992px
      </span>
      <span class="d-none badge badge-warning d-xl-inline-block d-xxl-none"> <i class="gel-icon-iphone disabled"></i><i class="gel-icon-tablet disabled"></i><i class="gel-icon-laptop"></i> - XL ≥ 1200px
      </span>
      <span class="d-none badge badge-info d-xxl-inline-block"> <i class="gel-icon-iphone disabled"></i><i class="gel-icon-tablet disabled"></i><i class="gel-icon-laptop scale-x"></i> - XXL ≥ 1600px
      </span>
    </div>
  </header>
</template>

<script>

export default {
  name: "Header",
  methods: {
    openMenu: function () {
      this.$store.commit('menu/open')
    }
  },
  props: {
    title: String,
    tagline: String
  }
};
</script>
